import React from 'react';
import { NavLink } from 'react-router-dom';
import { getSourceString } from '../../../helpers/StringHelper';
import { Tooltip } from 'antd';
import moment from 'moment';

export const linkingColumns = (t, module = 'pme') => [
  {
    title: t('Type of Subject'),
    dataIndex: 'type',
    key: 'type',
    show: true,
    project: true,
    search: true,
    render: type => t(type),
    searchType: 'dropdown',
  },
  {
    title: t('System ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    show: true,
    project: true,
    sorter: () => 0 + 0,
    render: (id, item) => {
      let link = '';
      switch (item.type) {
        case 'stakeholder':
          link = `/app/${module}/stakeholders/${id}`;
          break;
        case 'event':
          link = `/app/${module}/events/${id}`;
          break;
        case 'location':
          link = `/app/${module}/locations/${id}`;
          break;
        case 'lir':
          link = `/app/${module}/lir/${id}`;
          break;
        default:
          link = '#';
          break;
      }
      return <NavLink className="projectLink" to={link}>
        {id}
      </NavLink>
    },
    search: true,
  },
  {
    title: t('Name'),
    dataIndex: 'name',
    key: 'name',
    show: true,
    project: true,
    render: (name) => t(name),
    search: true,
  },
  {
    title: t('Connected as'),
    dataIndex: 'usedAs',
    key: 'usedAs',
    show: true,
    project: true,
    render: (used) => {
      const language = localStorage.getItem('datastakeLng') || 'en';
      return used[language];
    },
    search: true,
  },
];

const columns = (t, module = 'pme', view = '', filterBy = 'show', sourceId, activeFilters = {}) => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      project: true,
      overview: true,
      ellipsis: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      render: (id, item) => {
        const redirectUrl = item.authorId
          ? `/app/${module}/view/lir/${id}?sourceId=${item.authorId}`
          : `/app/${module}/view/lir/${id}`;
        return sourceId === 'overview' && item.children ? id : <NavLink
          className="projectLink"
          to={redirectUrl}
          {...(filterBy === 'publication' ? {
            target: "_blank"
          } : {})}
        >
          {id}
        </NavLink>
      },
      search: true,
      publication: true,
      width: 140,
    },
    {
      title: t('Type'),
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
      dataIndex: 'type',
      key: 'type',
      show: true,
      project: true,
      search: true,
      overview: true,
      searchType: 'dropdown',
      publication: true,
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'name' ? activeFilters.sortDir : undefined,
      show: true,
      project: true,
      overview: true,
      primarySearch: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Sources'),
      dataIndex: 'sourcesLen',
      key: 'sourcesLen',
      overview: true,
      search: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      show: true,
      project: true,
      search: true,
      searchType: 'dropdown',
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Province'),
      dataIndex: 'province',
      key: 'province',
      show: true,
      project: true,
      search: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'territory',
      key: 'territory',
      show: true,
      project: true,
      search: true,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Author'),
      dataIndex: 'author',
      key: 'author',
      show: false,
      project: true,
      search: true,
      publication: false,
      render: (author, item) => {
        const title = getSourceString(author, item);
        return <Tooltip title={title}>{title}</Tooltip>;
      },
      ellipsis: true,
    },
    {
      title: t('Version'),
      dataIndex: 'version',
      key: 'version',
      show: false,
      publication: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Last Update'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      show: true,
      project: true,
      search: false,
      publication: true,
      ellipsis: true,
      render: (updatedAt, item) => {
        const date = item.publishedAt || updatedAt;
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      }
    },
    // {
    //   title: t('City'),
    //   dataIndex: 'city',
    //   key: 'city',
    //   show: true,
    //   project: true,
    //   search: true,
    // },
  ];
  return cols.filter(col => col[filterBy]);
}

export default columns;
